import React from 'react'
import {
  useHistory,
  useLocation,
} from 'react-router-dom/cjs/react-router-dom.min'

import useBuildingsApi from '../hooks/buildings/useBuildingsApi'
import BuildingForm from '../components/buildings/BuildingForm'

export default function CreateBuildingPage() {
  const location = useLocation()
  const history = useHistory()

  const [_, methods] = useBuildingsApi()

  return (
    <BuildingForm
      onSubmit={(values) => {
        if (values.id) {
          methods.updateBuilding(values)
        } else {
          methods.createBuilding(values)
        }
      }}
      handleCancel={() => history.push('/edificios')}
      building={location.state && location.state.building}
    />
  )
}
